'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onPageLoadComplete = onPageLoadComplete;
/**
 * @description Executes the given callback, once the page is completely loaded.
 * @summary
 * Because scripts are loaded asynchronously (using script[async]) the page
 * may or may not have been completely loaded once the script is executed.
 *
 * This means, that listening for the 'DOMContentLoaded' Event is unreliable since
 * it may have already been fired.
 *
 * @param {Function} callback
 * @returns {void}
 */
function onPageLoadComplete(callback) {
    if (document.readyState !== 'loading') {
        callback();
        return;
    }

    document.addEventListener('DOMContentLoaded', callback);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/target-enhancement/node_modules/@nimius/event-utility/src/on-page-load-completed.js
// module id = 143
// module chunks = 4